import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer } from 'react-router-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './rootSaga';
import invoiceReducer from './Redux/reducer';

export default function configureStore(preloadedState) {
  // 실행환경 알아오기
  // const env = process.env.NODE_ENV;

  // history 생성
  // const history = createHistory();

  // redux-saga middleware
  const sagaMiddleWare = createSagaMiddleware();

  // middlewares -> thunk, routerMiddleware 등
  const middlewares = [thunk];

  // 개발환경일때 redux-logger 활성화
  //   if (env === 'development') {
  //     const {logger} = require('redux-logger');
  //     middlewares.push(logger);
  //   }

  // 하부 리듀서 합셔서 리듀서 생성
  const reducer = combineReducers({
    routing: routerReducer,
    // post,
    reducer: invoiceReducer,
  });

  let store;

  // if (env === 'development') {
  store = createStore(
    reducer,
    composeWithDevTools(applyMiddleware(sagaMiddleWare, ...middlewares))
  );
  // }
  // else {
  //   store = createStore(reducer, applyMiddleware(sagaMiddleWare, ...middlewares));
  // }

  sagaMiddleWare.run(rootSaga);

  // export default store();
  return store;
}
